import { Dialog, ModalDialog } from '@pelckmans/business-components/components/dialog';
import { ReactNode, useContext } from 'react';
import ModalContext from '../../../contexts/ModalContext';
import { useTranslation } from 'react-i18next';
import MaterialModalHeader from './common/MaterialModalHeader';
import { Node } from '../_api/TableOfContentsApi';

type Props = {
  contentType: ReactNode;
  id: string;
  name: string;
  node: Node;
  url: string;
};

export default function EmbeddableMediaModal({ contentType, id, name, node, url }: Props) {
  const { closeModal } = useContext(ModalContext);
  const { t } = useTranslation();

  return (
    <ModalDialog
      id={id}
      closeViaEscape
      closeOnClickOutside
      closeTitle={t('ACTIONS.CLOSE')}
      onClose={() => closeModal(id)}
      className="material-dialog embeddable-media-modal"
    >
      <MaterialModalHeader title={name} description={node.description} contentType={contentType} />
      <Dialog.Body>
        <iframe
          role="presentation"
          title={name}
          src={url}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
        />
      </Dialog.Body>
    </ModalDialog>
  );
}
